import { ReactElement, useEffect, useRef } from "react";
import { gsap } from "@rotorstudios/fe-modules";
import { useUiContext } from "@rotorstudios/fe-ui";

import { useDataContext } from "../../modules/Data/DataProvider";
import "./_UiMLoading.scss";

const UiMLoading = (): ReactElement => {
  const { breakpointActive, projectClass } = useUiContext();
  const { isLoading } = useDataContext();

  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    gsap.to(ref.current, {
      autoAlpha: isLoading ? 1 : 0,
      duration: isLoading ? 0.5 : 1,
      ease: isLoading ? "power4" : "power2",
    });
  }, [isLoading]);

  return (
    <div ref={ref} className={`${projectClass}_UiMLoading ${breakpointActive}`}>
      <span className="loader" />
    </div>
  );
};

export default UiMLoading;
